module.exports = __webpack_public_path__ + "static/media/test5_2.ea9a3b6c.png";